import React from 'react'
import { IconInfo } from '../../../components'
import { useFullScreenImageStore } from '../../../components/FullScreenImage'
import { WemoloTypography } from '../../../components/Wemolo'
import { convertTimestampToVisible } from '../utils'
import styles from './CaseItem.module.css'

interface CaseItemProps {
    plate: string
    timestamp: string
    deviceName: string
    plateNumber: string | React.ReactNode
    imageSrc: string
    height?: string
    title?: string
    direction?: string
    category?: string
    isCaseOver24Hours?: boolean
    lpness?: number | null
    lpr?: number | null
}

const formatScore = (value: number | null | undefined) => {
    if (value === null || value === undefined) return 'N/A'
    return value.toFixed(3)
}

export const CaseItem: React.FC<CaseItemProps> = ({
    plate,
    timestamp,
    deviceName,
    plateNumber,
    imageSrc,
    height = '20vh',
    title,
    direction,
    category,
    isCaseOver24Hours,
    lpness,
    lpr
}) => {
    const openImageFullScreen = useFullScreenImageStore((state) => state.openImageFullScreen)
    return (
        <div className={styles.root} style={{ maxHeight: height }}>
            <div className={styles.column} style={{ maxHeight: height }}>
                {title && (
                    <div className={styles.rowStart}>
                        <WemoloTypography variant="title-xsmall" tag="span">
                            {title}
                        </WemoloTypography>
                    </div>
                )}
                <div className={styles.imageContainer} style={{ height: height, width: `calc(${height} * (16/9))` }}>
                    <img
                        onClick={() => {
                            openImageFullScreen(imageSrc, title || '')
                        }}
                        src={imageSrc}
                        alt="Event"
                        className={styles.eventImage}
                    />
                </div>
                <div className={styles.rowStart}>
                    {category && <IconInfo icon={'category'} value={category} />}
                    <IconInfo
                        red={isCaseOver24Hours}
                        icon={'access_time'}
                        value={convertTimestampToVisible(timestamp)}
                    />
                    <IconInfo icon={'videocam'} value={deviceName} />
                    {direction && <IconInfo icon={'directions'} value={direction} />}
                </div>
            </div>

            <div className={styles.plateColumn}>
                <div className={styles.rowStart}>
                    <WemoloTypography variant="body-large-emphasized" tag="span">
                        {plateNumber}
                    </WemoloTypography>
                </div>
                <div>
                    <img
                        onClick={() => {
                            openImageFullScreen(plate, plateNumber || '', '300px')
                        }}
                        src={plate}
                        alt="Plate"
                        className={styles.plateImage}
                    />
                </div>
                {(lpness !== undefined || lpr !== undefined) && (
                    <div className={styles.scoreColumn}>
                        <WemoloTypography variant="body-small" tag="span">
                            {`lpness: ${formatScore(lpness)}`}
                        </WemoloTypography>
                        <WemoloTypography variant="body-small" tag="span">
                            {`lpr: ${formatScore(lpr)}`}
                        </WemoloTypography>
                    </div>
                )}
            </div>
        </div>
    )
}
